/* NOQA Reset — craving intensity slider (web port of NOQA_CravingSlider_Extract.swift)
   Widget-only scope: emoji band row + N/10 + native-feel slider. The capture
   flow chrome (top bar, Next, dots) stays in the app. Builds all DOM + styles
   inside #noqa-cravings-root. No external dependencies.
   Claude batch R2 — 17 Jul 2026. */
(function () {
  'use strict';

  var root = document.getElementById('noqa-cravings-root');
  if (!root || root.dataset.crvInit) return;
  root.dataset.crvInit = '1';

  /* ---------- Palette (SliderPalette) ---------- */
  var PINK = '#FF19E4';           // pinkPony
  var TRACK_REST = 'rgba(120,120,128,0.36)';   // iOS dark-mode unfilled track

  /* ---------- Bands (CravingIntensity) ---------- */
  function bandFor(v) { return v <= 3 ? 'mild' : v <= 6 ? 'moderate' : 'severe'; }
  var BAND_LABEL = { mild: 'Mild', moderate: 'Moderate', severe: 'Severe' };
  var BAND_EMOJI = { mild: '😃', moderate: '😒', severe: '😭' };

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Styles ----------
     Active box 101, inactive 53 * 0.95 extra scale -> wrapper scale .498.
     Band switch: spring(response .32, damping .75) ~ overshoot bezier.
     Personality cycles (phase -1 <-> +1, easeInOut, autoreverse):
       mild     scale ±.04, rot ±2.5deg, 1.5s
       moderate rot ±6deg, 2.0s
       severe   x ±3px, rot ±2deg, scale ±.02, 0.22s */
  var style = document.createElement('style');
  style.textContent =
    '.noqa-crv{position:relative;width:min(450px,92vw);margin-inline:auto;display:flex;flex-direction:column;align-items:center;gap:26px;--u:1;}' +
    '.noqa-crv__row{display:flex;justify-content:space-between;align-items:center;width:100%;padding-inline:calc(28px*var(--u));box-sizing:border-box;}' +
    '.noqa-crv__cell{width:calc(101px*var(--u));height:calc(101px*var(--u));display:flex;align-items:center;justify-content:center;}' +
    '.noqa-crv__wrap{transition:transform .35s cubic-bezier(0.34,1.3,0.64,1),opacity .35s cubic-bezier(0.34,1.3,0.64,1);will-change:transform;}' +
    '.noqa-crv__cell[data-active="0"] .noqa-crv__wrap{transform:scale(0.498);opacity:0.55;}' +
    '.noqa-crv__cell[data-active="1"] .noqa-crv__wrap{transform:scale(1);opacity:1;}' +
    '.noqa-crv__g{display:block;font-size:calc(87px*var(--u));line-height:1;transition:transform .25s ease-out;}' +
    '.noqa-crv__cell[data-active="1"] .noqa-crv__g.anim-mild{animation:noqa-crv-mild 1.5s ease-in-out infinite alternate;}' +
    '.noqa-crv__cell[data-active="1"] .noqa-crv__g.anim-moderate{animation:noqa-crv-moderate 2s ease-in-out infinite alternate;}' +
    '.noqa-crv__cell[data-active="1"] .noqa-crv__g.anim-severe{animation:noqa-crv-severe .22s ease-in-out infinite alternate;}' +
    '@keyframes noqa-crv-mild{from{transform:scale(0.96) rotate(-2.5deg);}to{transform:scale(1.04) rotate(2.5deg);}}' +
    '@keyframes noqa-crv-moderate{from{transform:rotate(-6deg);}to{transform:rotate(6deg);}}' +
    '@keyframes noqa-crv-severe{from{transform:translateX(-3px) rotate(-2deg) scale(0.98);}to{transform:translateX(3px) rotate(2deg) scale(1.02);}}' +
    '.noqa-crv__value{display:flex;flex-direction:column;align-items:center;gap:4px;}' +
    '.noqa-crv__num{font-family:"kit-sans","futura-pt",ui-rounded,system-ui,sans-serif;font-weight:900;font-size:calc(56px*var(--u));line-height:1;color:' + PINK + ';}' +
    '.noqa-crv__num.tick{animation:noqa-crv-tick .2s ease-out;}' +
    '@keyframes noqa-crv-tick{from{opacity:.35;transform:translateY(-0.05em);}to{opacity:1;transform:none;}}' +
    '.noqa-crv__band{font-family:"futura-pt",system-ui,sans-serif;font-weight:500;font-size:calc(16px*var(--u));color:#fff;}' +
    '.noqa-crv__track{width:100%;padding-inline:calc(20px*var(--u));box-sizing:border-box;}' +
    /* hardened: the theme styles inputs via high-specificity :not() chains
       (white capsule background, fixed height) - neutralise every box prop */
    '.noqa-crv input.noqa-crv__slider{-webkit-appearance:none !important;appearance:none !important;display:block;width:100% !important;height:28px !important;min-height:0 !important;background:transparent !important;background-color:transparent !important;border:0 !important;border-radius:0 !important;padding:0 !important;margin:0 !important;box-shadow:none !important;outline:none;cursor:pointer;}' +
    '.noqa-crv input.noqa-crv__slider::-webkit-slider-runnable-track{height:4px !important;border-radius:2px !important;background:var(--fill) !important;border:0 !important;box-shadow:none !important;}' +
    '.noqa-crv input.noqa-crv__slider::-webkit-slider-thumb{-webkit-appearance:none !important;appearance:none !important;width:28px !important;height:28px !important;border-radius:50% !important;background:#fff !important;border:none !important;box-shadow:0 3px 8px rgba(0,0,0,0.35),0 0 1px rgba(0,0,0,0.2) !important;margin-top:-12px !important;}' +
    '.noqa-crv input.noqa-crv__slider::-moz-range-track{height:4px !important;border-radius:2px !important;background:' + TRACK_REST + ' !important;border:0 !important;}' +
    '.noqa-crv input.noqa-crv__slider::-moz-range-progress{height:4px !important;border-radius:2px !important;background:' + PINK + ' !important;}' +
    '.noqa-crv input.noqa-crv__slider::-moz-range-thumb{width:28px !important;height:28px !important;border-radius:50% !important;background:#fff !important;border:none !important;box-shadow:0 3px 8px rgba(0,0,0,0.35) !important;}';
  document.head.appendChild(style);

  /* ---------- DOM ---------- */
  var el = document.createElement('div');
  el.className = 'noqa-crv';
  el.innerHTML =
    '<div class="noqa-crv__row">' +
      ['mild', 'moderate', 'severe'].map(function (k) {
        return '<div class="noqa-crv__cell" data-kind="' + k + '" data-active="0">' +
          '<span class="noqa-crv__wrap"><span class="noqa-crv__g" role="img" aria-label="' +
          BAND_LABEL[k] + '">' + BAND_EMOJI[k] + '</span></span></div>';
      }).join('') +
    '</div>' +
    '<div class="noqa-crv__value">' +
    '  <div class="noqa-crv__num">5/10</div>' +
    '  <div class="noqa-crv__band">Moderate</div>' +
    '</div>' +
    '<div class="noqa-crv__track">' +
    '  <input class="noqa-crv__slider" type="range" min="1" max="10" step="1" value="5" aria-label="Craving intensity">' +
    '</div>';
  root.appendChild(el);

  var cells = el.querySelectorAll('.noqa-crv__cell');
  var glyphs = el.querySelectorAll('.noqa-crv__g');
  var numEl = el.querySelector('.noqa-crv__num');
  var bandEl = el.querySelector('.noqa-crv__band');
  var slider = el.querySelector('.noqa-crv__slider');

  /* ---------- Sizing (viewport-safe: never trust a shrink-wrap parent) ---------- */
  function resize() {
    var w = el.getBoundingClientRect().width || 390;
    el.style.setProperty('--u', String(Math.max(0.62, Math.min(1.1, w / 390))));
  }
  window.addEventListener('resize', resize);
  if ('ResizeObserver' in window) {
    new ResizeObserver(function () { resize(); }).observe(el);
  }

  /* ---------- State ---------- */
  var current = -1;

  function update(v, animateNum) {
    var band = bandFor(v);
    for (var i = 0; i < cells.length; i++) {
      var kind = cells[i].getAttribute('data-kind');
      var active = kind === band;
      cells[i].setAttribute('data-active', active ? '1' : '0');
      var g = glyphs[i];
      var cls = 'anim-' + kind;
      if (active && !reduceMotion) {
        if (!g.classList.contains(cls)) {
          // restart from the same anchor every activation (app: phase = -1)
          g.classList.remove(cls);
          void g.offsetWidth;
          g.classList.add(cls);
        }
      } else {
        g.classList.remove(cls);   // settles back via the .25s ease-out transition
      }
    }
    numEl.textContent = v + '/10';
    if (animateNum) {
      numEl.classList.remove('tick');
      void numEl.offsetWidth;
      numEl.classList.add('tick');
    }
    bandEl.textContent = BAND_LABEL[band];
    var p = (v - 1) / 9 * 100;
    slider.style.setProperty('--fill',
      'linear-gradient(to right, ' + PINK + ' 0%, ' + PINK + ' ' + p + '%, ' +
      TRACK_REST + ' ' + p + '%, ' + TRACK_REST + ' 100%)');
    slider.setAttribute('aria-valuetext', v + ' out of 10, ' + BAND_LABEL[band]);
    if (v !== current && current !== -1 && navigator.vibrate) navigator.vibrate(8);
    current = v;
  }

  slider.addEventListener('input', function () {
    update(parseInt(slider.value, 10), true);
  });

  resize();
  update(5, false);
})();
